import { useRouter } from '@fabric-app/compat';
import { omit } from '@fabric-app/utils/object/manipulation';
import { useCallback } from 'react';
import { create } from 'zustand';
import { delayedTrackZustand } from '@fabric-app/compat/capabilities/openreplay';

const useSearchOverlayStore = create()(delayedTrackZustand((set) => ({
  isSearchOverlayOpen: false,
  onCloseOverlayOnce: void 0,
  setIsSearchOverlayOpen: (open, options) => set({
    isSearchOverlayOpen: open,
    onCloseOverlayOnce: options?.onCloseOverlayOnce || void 0
  })
})));
const useSearchOverlay = () => {
  const router = useRouter();
  const { isSearchOverlayOpen, setIsSearchOverlayOpen, onCloseOverlayOnce } = useSearchOverlayStore();
  return {
    isOverlayOpen: isSearchOverlayOpen,
    openOverlay: useCallback((type, options) => {
      router.push({
        pathname: router.pathname,
        query: {
          ...omit(router.query, [
            "openSearch",
            "expandedFdocId"
          ]),
          search: type
        }
      });
      setIsSearchOverlayOpen(true, options);
    }, [
      router,
      setIsSearchOverlayOpen
    ]),
    closeOverlay: useCallback(() => {
      const { search, ...query } = router.query;
      onCloseOverlayOnce?.();
      setIsSearchOverlayOpen(false, {
        onCloseOverlayOnce: void 0
      });
      if (search) {
        router.replace({
          pathname: router.pathname,
          query
        });
      }
    }, [
      router,
      setIsSearchOverlayOpen,
      onCloseOverlayOnce
    ])
  };
};

export { useSearchOverlay };
//# sourceMappingURL=useSearchOverlay.js.map
